import { IonImg, IonItem, IonList } from "@ionic/react";
import React from "react";
import { useHistory } from "react-router";
import "./Breadcrumb.scss";

export interface BreadcrumbItem {
  name: string;
  backUrl: string;
}
export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  data?: any;
}

export const Breadcrumb: React.FunctionComponent<BreadcrumbProps> = (
  props: BreadcrumbProps
) => {
  const history = useHistory();

  return (
    <IonList className="breadcrumb">
      {props.items.map((item: BreadcrumbItem, index: number) => {
        return (
          (index == props.items.length - 1 && (
            <IonItem className="breadcrumb-list-item active-item" key={`breadcrumb-${index}`}>
              {item.name}
            </IonItem>
          )) || (
            <IonItem className="breadcrumb-list-item" key={`breadcrumb-${index}`}>
              <span
                onClick={() => {
                  history.push(item.backUrl, {...props.data});
                }}
                className="nav-link"
              >
                {item.name}
              </span>
              <IonItem className="ion-chevron-right">
                <IonImg
                  src="assets/icon/chevron-forward-outline.svg"
                  className="chevron-icon"
                />
              </IonItem>
            </IonItem>
          )
        );
      })}
    </IonList>
  );
};
